import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,[_c(VAlert,{staticClass:"mt-2",attrs:{"border":"left","color":"orange","dense":"","text":"","type":"warning","icon":"mdi-alert-outline"}},[_vm._v(" "+_vm._s(_vm.$t("general.titles.warningUploadTemplate"))+" "),_c(VBtn,{attrs:{"text":"","color":"#d68000"},on:{"click":_vm.downloadTemplate}},[_vm._v(_vm._s(_vm.$t("general.titles.nomenclators.downloadTemplate")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }